// extracted by mini-css-extract-plugin
export default {"MobilePhone":"MobilePhone_MobilePhone__3qV43","MobilePhone__icon":"MobilePhone_MobilePhone__icon__2-sqn"};